"use strict";

exports.__esModule = true;
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("./Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var links = {};

function _default(url, fontFamily, prefix) {
  if (fontFamily === void 0) {
    fontFamily = 'iconfont';
  }

  if (prefix === void 0) {
    prefix = 'icon';
  }

  if (url && !links[url]) {
    links[url] = true;
    var link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', url);
    document.head.appendChild(link);
  }

  var wrapperIcon = function wrapperIcon(props) {
    return _react.default.createElement(_Icon.default, _extends({
      fontFamily: fontFamily,
      prefix: prefix
    }, props));
  };

  wrapperIcon.isShineoutIcon = true;
  return wrapperIcon;
}